/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: DiDiSansPro, SF Pro Text, PingFang SC, PingFang TC, Meiryo, Microsoft Sans Serif, Microsoft YaHei, Microsoft JhengHei, Helvetica Neue, Helvetica, Arial, Sans-serif
 */
var $font_family = 'DiDiSansPro, SF Pro Text, PingFang SC, PingFang TC, Meiryo, Microsoft Sans Serif, Microsoft YaHei, Microsoft JhengHei, Helvetica Neue, Helvetica, Arial, Sans-serif';
var $font_size_1 = 12;
var $font_size_2 = 14;
var $font_size_3 = 16;
var $font_size_4 = 18;
var $font_size_5 = 20;
var $font_size_6 = 24;
// 与现有的desgin token保持一致
var $font_size_7 = 28;
var $font_size_8 = 32;
var $font_size_9 = 36;
var $font_size_10 = 48;

/**
 * @desc 行高计算: font-style(size:12px; lineheight:18px)
 */
var $line_height_1 = 18 / 12;
/**
 * @desc 行高计算: font-style(size:14px; lineheight:20px)
 * @example 1.5714285714285714 = 22 / 14 (line-height / font-size)
 */
var $line_height_2 = 20 / 14;
/**
 * @desc 行高计算: font-style(size:16px; lineheight:24px)
 */
var $line_height_3 = 24 / 16;
/**
 * @desc 行高计算: font-style(size:18px; lineheight:28px)
 */
var $line_height_4 = 28 / 18;
/**
 * @desc 行高计算: font-style(size:20px; lineheight:30px)
 */
var $line_height_5 = 30 / 20;
/**
 * @desc 行高计算: font-style(size:24px; lineheight:36px)
 */
var $line_height_6 = 36 / 24;
// 与现有的desgin token保持一致
/**
 * @desc 行高计算: font-style(size:28px; lineheight:42px)
 */
var $line_height_7 = 42 / 28;
/**
 * @desc 行高计算: font-style(size:32px; lineheight:48px)
 */
var $line_height_8 = 48 / 32;
/**
 * @desc 行高计算: font-style(size:36px; lineheight:54px)
 */
var $line_height_9 = 54 / 36;
/**
 * @desc 行高计算: font-style(size:48px; lineheight:72px)
 */
var $line_height_10 = 72 / 48;

/**
 * 强调文字/标题-大
 * @description enDesc: Operating Title - Large
 * @description type: alias
 * @description  globalToken: $font-size-10
 * @description  value: 56px
 */
var $font_size_display_lg = $font_size_10;

/**
 * 强调文字/标题-中
 * @description enDesc: Operation Title - Medium
 * @description type: alias
 * @description  globalToken: $font-size-9
 * @description  value: 48px
 */
var $font_size_display_md = $font_size_9;

/**
 * 标题-加加加大（非常特殊重要标题）
 * @description enDesc: Operation Title - Small
 * @description type: alias
 * @description  globalToken: $font-size-8
 * @description  value: 32px
 */
var $font_size_h1 = $font_size_8;

/**
 * 标题-加加大（特殊重要标题）
 * @description enDesc: Title - Big
 * @description type: alias
 * @description  globalToken: $font-size-6
 * @description  value: 24px
 */
var $font_size_h2 = $font_size_6;

/**
 * 标题-加大（页面标题）
 * @description enDesc: Title - Medium
 * @description type: alias
 * @description  globalToken: $font-size-5
 * @description  value: 20px
 */
var $font_size_h3 = $font_size_5;

/**
 * 标题-大（区域标题）
 * @description enDesc: Title - Small
 * @description type: alias
 * @description  globalToken: $font-size-4
 * @description  value: 18px
 */
var $font_size_h4 = $font_size_4;

/**
 * 标题-中（局部标题）
 * @description enDesc: Body - regular - large
 * @description type: alias
 * @description  globalToken: $font-size-3
 * @description  value: 16px
 */
var $font_size_h5 = $font_size_3;

/**
 * 标题-小（小标题和局部副标题）
 * @description enDesc: Regular - regular - small
 * @description type: alias
 * @description  globalToken: $font-size-3
 * @description  value: 16px
 */
var $font_size_h6 = $font_size_3;

/**
 * 正文-常规-大（正文内容重点）
 * @description enDesc: Auxiliary Copywriting/Secondary Copywriting
 * @description type: alias
 * @description  globalToken: $font-size-3
 * @description  value: 16px
 */
var $font_size_lg_text = $font_size_3;

/**
 * 正文-常规-中（正文大部分文字）
 * @description enDesc: Watermark text
 * @description type: alias
 * @description  globalToken: $font-size-2
 * @description  value: 14px
 */
var $font_size_base_text = $font_size_2;

/**
 * 正文-常规-小（正文大部分文字）
 * @description enDesc: Watermark text
 * @description type: alias
 * @description  globalToken: $font-size-1
 * @description  value: 12px
 */
var $font_size_sm_text = $font_size_1;

/**
 * 脚注、水印等
 * @description enDesc: Watermark text
 * @description type: alias
 * @description  globalToken: $font-size-1
 * @description  value: 14px
 */
var $font_size_caption = $font_size_1;

/**
 * $font_size-display-lg 的行高
 * @description enDesc: Operating Title - Large
 * @description type: alias
 * @description  globalToken: $line-height-10
 * @description  value: 56px
 */
var $line_height_display_lg = $line_height_10;

/**
 * $font_size-display-md 的行高
 * @description enDesc: Operation Title - Medium
 * @description type: alias
 * @description  globalToken: $line-height-9
 * @description  value: 48px
 */
var $line_height_display_md = $line_height_9;

/**
 * $font_size-h1 的行高
 * @description enDesc: Operation Title - Small
 * @description type: alias
 * @description  globalToken: $line-height-8
 * @description  value: 36px
 */
var $line_height_h1 = $line_height_8;

/**
 * $font_size-h2 的行高
 * @description enDesc: Title - Big
 * @description type: alias
 * @description  globalToken: $line-height-7
 * @description  value: 32px
 */
var $line_height_h2 = $line_height_7;

/**
 * $font_size-h3 的行高
 * @description enDesc: Title - Medium
 * @description type: alias
 * @description  globalToken: $line-height-6
 * @description  value: 24px
 */
var $line_height_h3 = $line_height_6;

/**
 * $font_size-h4 的行高
 * @description enDesc: Title - Small
 * @description type: alias
 * @description  globalToken: $line-height-5
 * @description  value: 20px
 */
var $line_height_h4 = $line_height_5;

/**
 * $font_size-h5 的行高
 * @description enDesc: Body - regular - large
 * @description type: alias
 * @description  globalToken: $line-height-4
 * @description  value: 18px
 */
var $line_height_h5 = $line_height_4;

/**
 * $font_size-h6 的行高
 * @description enDesc: Regular - regular - small
 * @description type: alias
 * @description  globalToken: $line-height-3
 * @description  value: 16px
 */
var $line_height_h6 = $line_height_3;

/**
 * $font_size-lg-text 的行高
 * @description enDesc: Auxiliary Copywriting/Secondary Copywriting
 * @description type: alias
 * @description  globalToken: $line-height-3
 * @description  value: 16px
 */
var $line_height_lg_text = $line_height_3;

/**
 * $font_size-base-text 的行高
 * @description enDesc: Watermark text
 * @description type: alias
 * @description  globalToken: $line-height-2
 * @description  value: 14px
 */
var $line_height_base_text = $line_height_2;

/**
 * $font_size-sm-text 的行高
 * @description enDesc: Watermark text
 * @description type: alias
 * @description  globalToken: $line-height-1
 * @description  value: 14px
 */
var $line_height_sm_text = $line_height_1;

/**
 * $font_size-caption 的行高
 * @description enDesc: Watermark text
 * @description type: alias
 * @description  globalToken: $line-height-1
 * @description  value: 14px
 */
var $line_height_caption = $line_height_1;

/**
 * 黑体 Black
 * @description enDesc: Black Body Black
 * @description type: global
 * @description  globalToken: -
 * @description  value: 900
 */
var $font_weight_900 = 900;

/**
 * 中黑 ExtraBold
 * @description enDesc: Medium Black ExtraBold
 * @description type: global
 * @description  globalToken: -
 * @description  value: 800
 */
var $font_weight_800 = 800;

/**
 * 粗体 Bold
 * @description enDesc: Bold
 * @description type: global
 * @description  globalToken: -
 * @description  value: 700
 */
var $font_weight_700 = 700;

/**
 * 半粗 SemiBold
 * @description enDesc: SemiBold
 * @description type: global
 * @description  globalToken: -
 * @description  value: 600
 */
var $font_weight_600 = 600;

/**
 * 中等 Medium
 * @description enDesc: Medium
 * @description type: global
 * @description  globalToken: -
 * @description  value: 500
 */
var $font_weight_500 = 500;

/**
 * 常规 Regular
 * @description enDesc: Regular Regular
 * @description type: global
 * @description  globalToken: -
 * @description  value: 400
 */
var $font_weight_400 = 400;

/**
 * 细体 Light
 * @description enDesc: Thin Body Light
 * @description type: global
 * @description  globalToken: -
 * @description  value: 300
 */
var $font_weight_300 = 300;

/**
 * 纤细 Thin
 * @description enDesc: Thin
 * @description type: global
 * @description  globalToken: -
 * @description  value: 200
 */
var $font_weight_200 = 200;

/**
 * 极细 UltraLight
 * @description enDesc: UltraLight
 * @description type: global
 * @description  globalToken: -
 * @description  value: 100
 */
var $font_weight_100 = 100;

/**
 * 加粗字重的别名
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $font-weight-600
 * @description  value: 600
 */
var $font_weight_bold = $font_weight_600;

/**
 * 较粗字重的别名
 * @description enDesc: UltraLight
 * @description type: alias
 * @description  globalToken: $font-weight-500
 * @description  value: 500
 */
var $font_weight_medium = $font_weight_500;

/**
 * 常规字重的别名
 * @description enDesc: UltraLight
 * @description type: alias
 * @description  globalToken: $font-weight-400
 * @description  value: 400
 */
var $font_weight_regular = $font_weight_400;

/**
 * 纤细字重的别名
 * @description enDesc: UltraLight
 * @description type: alias
 * @description  globalToken: $font-weight-200
 * @description  value: 200
 */
var $font_weight_thin = $font_weight_200;

/**
 * undefined
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: Consolas, Menlo
 */
var $code_family = 'Consolas, Menlo';

export { $code_family, $font_family, $font_size_1, $font_size_10, $font_size_2, $font_size_3, $font_size_4, $font_size_5, $font_size_6, $font_size_7, $font_size_8, $font_size_9, $font_size_base_text, $font_size_caption, $font_size_display_lg, $font_size_display_md, $font_size_h1, $font_size_h2, $font_size_h3, $font_size_h4, $font_size_h5, $font_size_h6, $font_size_lg_text, $font_size_sm_text, $font_weight_100, $font_weight_200, $font_weight_300, $font_weight_400, $font_weight_500, $font_weight_600, $font_weight_700, $font_weight_800, $font_weight_900, $font_weight_bold, $font_weight_medium, $font_weight_regular, $font_weight_thin, $line_height_1, $line_height_10, $line_height_2, $line_height_3, $line_height_4, $line_height_5, $line_height_6, $line_height_7, $line_height_8, $line_height_9, $line_height_base_text, $line_height_caption, $line_height_display_lg, $line_height_display_md, $line_height_h1, $line_height_h2, $line_height_h3, $line_height_h4, $line_height_h5, $line_height_h6, $line_height_lg_text, $line_height_sm_text };
